import React from 'react';

const LoadingState = () => <div className="f-spinner"></div>;

export default LoadingState;
